/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingDiagnosticsResult
 */
export interface BookingDiagnosticsResult {
    /**
     * 
     * @type {string}
     * @memberof BookingDiagnosticsResult
     */
    correlationId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof BookingDiagnosticsResult
     */
    bookingResponse?: object | null;
}

export function BookingDiagnosticsResultFromJSON(json: any): BookingDiagnosticsResult {
    return BookingDiagnosticsResultFromJSONTyped(json, false);
}

export function BookingDiagnosticsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingDiagnosticsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correlationId': !exists(json, 'correlationId') ? undefined : json['correlationId'],
        'bookingResponse': !exists(json, 'bookingResponse') ? undefined : json['bookingResponse'],
    };
}

export function BookingDiagnosticsResultToJSON(value?: BookingDiagnosticsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correlationId': value.correlationId,
        'bookingResponse': value.bookingResponse,
    };
}


